// import { Avatar } from "@mui/material";
import { useEffect, useRef } from "react";
import { FlexCenterWrapper } from "../../../../../components/DefaultNoDataWrapper";
import Flex from "../../../../../components/Flex";
import Text from "../../../../../components/Text";
import { formatTime } from "../../../../../utils/date-time-utility";
import DateStrip from "../../patient/patient-list/patient-chart-new/patient-chronological-records-and-requiring-actions/DateStrip";
import ChatBubble from "./ChatBubble";
import noMessageImg from "/default-images/no-message.svg";

// type UserKeys =
//   | "patientId"
//   | "patientName"
//   | "providerColorCode"
//   | "providerId"
//   | "providerName"
//   | "sendAt"
//   | "sendBy"
//   | "smsContent"
//   | "uuid"
//   | "patientColor";

// type User = {
//   [k in UserKeys]: string;
// };

type Messages = Record<string, any[]>;

const MessageBox = ({ messages }: { messages?: Messages }) => {
  const bottomRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    bottomRef?.current?.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
    });
  }, []);

  const isMessages = Object.keys(messages ?? {}).length > 0;

  return !!isMessages ? (
    Object.entries(messages!)?.map(([date, dateMessages]) => {
      return (
        <div key={date}>
          <DateStrip date={date} />

          {dateMessages?.map((it) => {
            const isSender = it?.sendBy !== "Provider";
            return (
              <Flex
                key={it?.uuid}
                width={"100%"}
                justifyContent={isSender ? "start" : "end"}
                gap={2}
                mt={4}
              >
                <Flex gap={1} width={"55%"}>
                  {/* {isSender && (
                    <UserAvatar
                      user={it}
                      label={it?.patientName?.slice(0, 2)}
                    />
                  )} */}
                  <Flex
                    flexDirection={"column"}
                    width={"100%"}
                    alignItems={isSender ? "start" : "end"}
                  >
                    {/* todo need to unComment for multiple message at one time */}
                    {/* {it?.smsContent?.map((msg) => ( */}
                    <ChatBubble
                      color={isSender ? "#F4F4F4" : "#DBF2FF"}
                      message={it.smsContent}
                      isSender={!!isSender}
                    />
                    <Flex
                      justifyContent={isSender ? "start" : "end"}
                      width={"100%"}
                      height={"20px"}
                    >
                      <Flex gap={1} height={"15px"}>
                        <Text fontSize={"12px"}>
                          {isSender ? it?.patientName : it?.providerName}
                        </Text>
                        <Text fontSize={"12px"}>{formatTime(it?.sendAt)}</Text>
                      </Flex>
                    </Flex>
                    {/* ))} */}
                  </Flex>
                  {/* {!isSender && (
                    <UserAvatar
                      user={it}
                      label={it?.providerName?.slice(0, 2)}
                    />
                  )} */}
                </Flex>
              </Flex>
            );
          })}

          <div ref={bottomRef} />
        </div>
      );
    })
  ) : (
    <NoMessageAvailable />
  );
};

export default MessageBox;

// type UserAvatarProps = {
//   user: User;
//   size?: string;
//   label?: string;
// };

// const UserAvatar = ({ user, size = "30px", label }: UserAvatarProps) => {
//   return (
//     <Avatar
//       sx={{ bgcolor: user?.providerColorCode, height: size, width: size }}
//     >
//       <Text>{label ?? "Chat User"}</Text>
//     </Avatar>
//   );
// };

const NoMessageAvailable = () => (
  <FlexCenterWrapper>
    <img src={noMessageImg} alt={"No Message Available"} />
    <Text fontSize={"16px"}>No messages yet, Start the conversation ! </Text>
  </FlexCenterWrapper>
);
